export const BoardViewMode = {
  Week: 'week',
  List: 'list',
} as const;
export type BoardViewMode = (typeof BoardViewMode)[keyof typeof BoardViewMode];

export const SidebarMode = {
  Backlog: 'backlog',
  Note: 'note',
} as const;
export type SidebarMode = (typeof SidebarMode)[keyof typeof SidebarMode];

export const CARD_ROWS_SPAN = 4; // how much row cells card takes
export const GAP_SIZE = 8; // space between column groups
export const CELL_CARD_GAP = 2.5; // space between cell borders and card on grid
export const CELL_HEIGHT = 50;
export const CELL_WIDTH = 150;
export const BOARD_BOTTOM_PADDING = 40; // free space on the bottom of the board
export const BOARD_RIGHT_PADDING = 40; // free space on the right of the board

export const ROW_MINUTES = 30; // How much time in minutes row takes
export const START_HOUR = 8; // Start hour of the board
export const END_HOUR = 18; // End hour of the board
